import React from 'react';
import './Footer.css';
import { FacebookLogo, TwitterLogo, LinkedinLogo, YoutubeLogo, Phone } from '@phosphor-icons/react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="footer-logo-wrapper">
              <div className="footer-logo-split footer-icon-part">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5zi-LeU5pzY_unr4ecjxKxAcNEeBhkV_1Yw&s" alt="Icon" className="footer-logo-split-img" />
              </div>
              <div className="footer-logo-split footer-text-part">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5zi-LeU5pzY_unr4ecjxKxAcNEeBhkV_1Yw&s" alt="Text" className="footer-logo-split-img" />
              </div>
            </div>
          </div>
          <div className="social-links">
            <FacebookLogo size={24} color="#94a3b8" weight="fill" />
            <TwitterLogo size={24} color="#94a3b8" weight="fill" />
            <LinkedinLogo size={24} color="#94a3b8" weight="fill" />
            <YoutubeLogo size={24} color="#94a3b8" weight="fill" />
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Address</h4>
          <p className="footer-text">Aikya Vihar, B-Block,<br />Plot No.218, Kavuri Hills<br />Phase 2 Rd, Doctor's Colony,<br />Madhapur, Hyderabad,<br />Telangana 500033</p>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contacts</h4>
          <p className="footer-text flex items-center gap-2">
            <Phone size={18} weight="fill" />
            <span>+91 63047 65654</span>
          </p>
          <a href="mailto:vinushna.lakkakula@cabptoidsolutions.com" className="footer-link mt-4 block">vinushna.lakkakula@cabptoidsolutions.com</a>
          <a href="https://www.linkedin.com/in/vinushnalakkakula/" className="footer-link mt-2 flex items-center gap-2" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex' }}>
            <LinkedinLogo size={18} weight="fill" />
            <span>Vinushna Lakkakula</span>
          </a>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Services</h4>
          <ul className="footer-links">
            <li><a href="/">Mobile App Development</a></li>
            <li><a href="/">Web App Development</a></li>
            <li><a href="/">Native App Development</a></li>
            <li><a href="/">React JS Development</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>©Cabptoid 2025. All rights reserved.</p>
        <a href="/">Privacy Policy</a>
      </div>
    </footer>
  );
};

export default Footer;
